import React from 'react';
import {DataSearch} from '@appbaseio/reactivesearch';
import {textSearchContainer} from '../styles/Container';

const TextSearch = () => (
    <DataSearch
        autosuggest={true}
        className={textSearchContainer}
        componentId="textSearch"
        dataField={[
            'name', 'cfName', 'aliases'
        ]}
        debounce={200}
        filterLabel={"Search"}
        iconPosition="left"
        innerClass={{
            input: 'search-input',
        }}
        placeholder="Search"
        queryFormat={"and"}
        react={{
            and: ["model", "levelType", "derived", "enabled"]
        }}
        showClear={true}
		customQuery={(value, props) => ({
			bool: { // this is a boolean expression for elastic search
				should: [ // this is a "should have" in the query followed by a list of terms to apply
					{
						term: { // getting the name property, making it as a key for our search, from dataField -> name
							"name.keyword": {
								value: value
							}
						}
					},
					{
						term: {
							"cfName.keyword": {
								value: value
							}
						}
					},
					{
						term: {
							"aliases.keyword": {
								value: value
							}
						}
					},
					{ // in case the name does not match, we add .* to extend the results + security filtering the input
						regexp: {
							"name.keyword": {
								value: `.*${value.replace(/([.*+?^${}()|\[\]\\])/g, "\\$1")}.*`
							}
						}
					},
					{
						regexp: {
							"cfName.keyword": {
								value: `.*${value.replace(/([.*+?^${}()|\[\]\\])/g, "\\$1")}.*`
							}
						}
					},
					{
						regexp: {
							"aliases.keyword": {
								value: `.*${value.replace(/([.*+?^${}()|\[\]\\])/g, "\\$1")}.*`
							}
						}
					}
				]
			}
		})}
        URLParams
    />
);

export default TextSearch;



// WEBPACK FOOTER //
// ./src/components/TextSearch.js